import { render, staticRenderFns } from "./HolidaysManagedBySystemUser.vue?vue&type=template&id=e13a0d9c"
import script from "./HolidaysManagedBySystemUser.vue?vue&type=script&lang=js"
export * from "./HolidaysManagedBySystemUser.vue?vue&type=script&lang=js"
import style0 from "./HolidaysManagedBySystemUser.vue?vue&type=style&index=0&id=e13a0d9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports